import { render, staticRenderFns } from "./InvestmentAccountTypeSelector.vue?vue&type=template&id=7bae0721"
import script from "./InvestmentAccountTypeSelector.vue?vue&type=script&lang=ts"
export * from "./InvestmentAccountTypeSelector.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports